(function (angular) {
    'use strict';

    angular.module('shared')

        /**
         *
         */
        .factory('emailValidationService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    // urlBase = 'http://localhost:8002';

                    var fac = {
                        validateEmail: validateEmail,
                        startValidateEmail: startValidateEmail

                    };

                    return fac;

                    function validateEmail(accountId, data) {

                        return $http.post(urlBase + "/accounts/" + accountId + "/email/completeverify", data)
                            .then(validateEmailComplete)
                            .catch(validateEmailFailed);

                        function validateEmailComplete(response) {
                            return response.data;
                        }

                        function validateEmailFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    function startValidateEmail(accountId, data) {

                        return $http.post(urlBase + "/accounts/" + accountId + "/email/startverify", data)
                            .then(startValidateEmailComplete)
                            .catch(startValidateEmailFailed);

                        function startValidateEmailComplete(response) {
                            return response.data;
                        }

                        function startValidateEmailFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);

})(window.angular);